// @ts-nocheck
import { Box } from '@mui/material';
import React, { useCallback, useState, useEffect } from 'react';
import { getWasteTypesRequest } from '../../api/wasteTypeApi';
import { getInitialForm3Item } from '../../constants/lkCadastr/cadastrForm3';
import {
  fitContent, flexGap2, flexRowGap2, fullWidth,
} from '../../constants/lkCadastr/cadastrStorage';
import { compareId } from '../../helpers';
import { deleteForm3ReportGeneration } from '../../helpers/cadastreForms/form3Helper';
import { formatAddressString, getOktmoLabel } from '../../helpers/stringHelper';
import useCadastreTabs from '../../hooks/useCadastreTabs';
import { AsyncAutocomplete } from '../AutoCompletes/AsyncAutocomplete';
import AddButton from '../Buttons/AddButton';
import DeleteButton from '../Buttons/DeleteButton';
import CustomCheckbox from '../CustomCheckbox';
import CustomInput from '../Inputs';
import { DEFAULT_AUTOCOMPLETE_FIELD } from '../Inputs/CustomAutocomplete';
import NavTabs from '../Tabs';
import { Text, TextTitle } from '../Text';
import { CadastreForm3WasteTransfer } from './CadastreForm3WasteTransfer';
import { useCadastreStore } from '../../store';

export default function CadastreForm3Wastes({
  building,
  onChange,
  isDemo,
  buildingIndex,
  setCreateSubjectField,
  form3Items,
  changeItemFormByField,
  openDeleteModal,
  onNegativeAvailable,
}) {
  const { cadastreStore } = useCadastreStore();
  const mainItems = form3Items?.items || building?.waste_products;
  const [
    hasNegativeAvailableOnOrganisation,
    setHasNegativeAvailableOnOrganisation,
  ] = useState(false);

  useEffect(() => {
    if (onNegativeAvailable) onNegativeAvailable(hasNegativeAvailableOnOrganisation);
  }, [hasNegativeAvailableOnOrganisation, onNegativeAvailable]);

  const { tab, tabs, setTab } = useCadastreTabs({ items: mainItems, tabName: 'Отход' });

  const addNewWaste = () => {
    changeItemFormByField({
      field: 'form3.items',
      value: [...form3Items.items, getInitialForm3Item(true)],
    });
  };

  const getMainItem = useCallback((tabId) => mainItems.find((mainItem) => compareId(mainItem.randId, tabId)) || {}, [mainItems]);

  return (
    <Box sx={flexGap2}>
      {!building && (
        <CustomCheckbox
          label="Указать принимаемые отходы"
          value={form3Items.hasAcceptingWastes}
          onChange={(e, value) => changeItemFormByField({ field: 'form3.hasAcceptingWastes', value })}
          disabled={isDemo}
        />
      )}
      {(building || form3Items?.hasAcceptingWastes) && (
      <>
        {(!isDemo && form3Items?.hasAcceptingWastes) && (
          <AddButton variant="outlined" onClick={addNewWaste}>
            Добавить отход
          </AddButton>
        )}
        <NavTabs
          getErrorTab={(tabId) => {
            const mainItem = getMainItem(tabId);

            return cadastreStore.errorForm3?.some?.((item) => item.includes(mainItem.id));
          }}
          tabsComponents={tabs}
          setTab={setTab}
          tab={tab}
        />
        {building && (
        <>
          <Box>
            <Text className="mute">Адрес</Text>
            <CustomInput
              disabled
              debounceTime={0}
              sx={fullWidth}
              value={formatAddressString(building.objective_id?.address_attributes?.attributes)}
            />
          </Box>
          <Box>
            <Text className="mute">ОКТМО</Text>
            <CustomInput
              disabled
              debounceTime={0}
              sx={fullWidth}
              value={getOktmoLabel(building.objective_id?.address_attributes?.attributes?.oktmo_attributes?.attributes)}
            />
          </Box>
        </>
        )}

        {mainItems.map((waste_product, index) => {
          if (waste_product.randId !== tab) return null;

          const mainField = building ? `items.${buildingIndex}.waste_products.${index}.form3Waste.` : `items.${index}.`;

          const changeItem = (field, value, props) => {
            onChange({
              field: `${mainField}${field}`,
              value,
              buildingForm3Index: buildingIndex,
              reportGenerationIndex: index,
              ...props,
            });
          };

          const form3Waste = waste_product?.form3Waste || waste_product;

          const onDeleteWaste = async () => {
            const cloneArray = form3Items.items.slice();

            if (waste_product.id) {
              const deletedId = await deleteForm3ReportGeneration({ wasteId: waste_product.id });

              if (!deletedId) return;
            }

            cloneArray.splice(index, 1);

            changeItemFormByField({
              field: 'form3.items',
              value: cloneArray,
              type: 'delete',
            });
          };

          return (
            <Box key={waste_product.randId} sx={flexGap2}>
              <Box sx={flexRowGap2}>
                <TextTitle h2>
                  Отход №
                  {index + 1}
                </TextTitle>
                {!isDemo && form3Items?.hasAcceptingWastes && form3Items.items.length > 0 && (
                  <DeleteButton onClick={() => openDeleteModal(onDeleteWaste, index, 'Отход')}>
                    Удалить Отход
                  </DeleteButton>
                )}
              </Box>
              <Box>
                <Text className="mute">Код отхода по ФККО</Text>
                <AsyncAutocomplete
                  disabled={building || isDemo}
                  validImmediately={!building}
                  sx={fullWidth}
                  request={getWasteTypesRequest}
                  value={waste_product?.waste_type_id?.id ? waste_product?.waste_type_id : waste_product.code}
                  optionField={DEFAULT_AUTOCOMPLETE_FIELD}
                  onChange={(e, value) => changeItem('waste_type_id', value)}
                />
              </Box>
              <Box sx={flexGap2}>
                {building && (
                  <Box>
                    <Text className="mute">Образование отходов за отчетный период (Т)</Text>
                    <CustomInput
                      disabled
                      sx={fullWidth}
                      type="number"
                      decimalScale={3}
                      value={waste_product.quantity}
                    />
                  </Box>
                )}
                <Box>
                  <Text className="mute">Наличие отходов на начало отчетного периода (Т)</Text>
                  <CustomInput
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    sx={fullWidth}
                    type="number"
                    decimalScale={3}
                    value={form3Waste.availability_waste_period}
                    onChange={(e, value) => changeItem('availability_waste_period', value)}
                  />
                </Box>
                <Box>
                  <Text className="mute">Передано отходов региональному оператору по обращению с твердыми коммунальными отходами (Т)</Text>
                  <CustomInput
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    sx={fullWidth}
                    type="number"
                    decimalScale={3}
                    value={form3Waste.get_transfer_operator}
                    onChange={(e, value) => changeItem('get_transfer_operator', value)}
                  />
                </Box>
                <Box>
                  <Text className="mute">Обработка отходов на собственных объектах (Т)</Text>
                  <CustomInput
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    sx={fullWidth}
                    type="number"
                    decimalScale={3}
                    value={form3Waste.get_processing}
                    onChange={(e, value) => changeItem('get_processing', value)}
                  />
                </Box>
                <Box>
                  <Text className="mute">Утилизация отходов на собственных объектах (Т)</Text>
                  <CustomInput
                    validImmediately
                    debounceTime={0}
                    disabled={isDemo}
                    sx={fullWidth}
                    type="number"
                    decimalScale={3}
                    value={form3Waste.get_utilization}
                    onChange={(e, value) => changeItem('get_utilization', value)}
                  />
                </Box>
                <Box>
                  <Text className="mute">Обезвреживание отходов на собственных объектах (Т)</Text>
                  <CustomInput
                    validImmediately
                    disabled={isDemo}
                    sx={fullWidth}
                    type="number"
                    decimalScale={3}
                    value={form3Waste.get_neutralization}
                    onChange={(e, value) => changeItem('get_neutralization', value)}
                  />
                </Box>
                <Box sx={{ ...flexGap2, display: building ? 'none' : 'flex' }}>
                  <TextTitle h3>
                    Поступление отходов от других организаций
                  </TextTitle>
                  <Box sx={flexRowGap2}>
                    <Box>
                      <Text className="mute">Всего (Т)</Text>
                      <CustomInput
                        validImmediately
                        debounceTime={0}
                        disabled={isDemo}
                        sx={fitContent}
                        type="number"
                        decimalScale={3}
                        value={form3Waste.get_all}
                        onChange={(e, value) => changeItem('get_all', value)}
                      />
                    </Box>
                    <Box>
                      <Text className="mute">в т.ч. по импорту (Т)</Text>
                      <CustomInput
                        validImmediately
                        debounceTime={0}
                        disabled={isDemo}
                        sx={fitContent}
                        type="number"
                        decimalScale={3}
                        value={form3Waste.get_import}
                        onChange={(e, value) => changeItem('get_import', value)}
                      />
                    </Box>
                  </Box>
                </Box>
                <CadastreForm3WasteTransfer
                  isDemo={isDemo}
                  changeItem={changeItem}
                  buildingIndex={buildingIndex}
                  index={index}
                  openDeleteModal={openDeleteModal}
                  setCreateSubjectField={setCreateSubjectField}
                  items={form3Waste?.waste_transfers}
                  field={mainField}
                  f3waste={form3Waste}
                  wastequant={waste_product.quantity}
                  isBuilding={building != null}
                  onNegativeAvailable={setHasNegativeAvailableOnOrganisation}
                />
              </Box>
            </Box>
          );
        })}

      </>
      )}
    </Box>
  );
}
